import C from "../constants";
const user = (state = { loading: true, data: null }, action) => {
  switch (action.type) {
    case C.SET_USER:
      return action.payload;
    default:
      return state;
  }
};
export default user;
